export default __webpack_public_path__ + "static/media/logo.31bf3d08.png";